/* eslint-disable camelcase */
/*
 * 企業側 ホットライン相談申し込み 今後の進め方相談
 */
import { apiCreate } from '@/actions/ApiBaseActions';
export const API_UPDATE_CLIENT_HOTLINE_REQUEST_CONTACT_CREATE = 'API_UPDATE_CLIENT_HOTLINE_REQUEST_CONTACT_CREATE';
/**
 * クライアント：今後の進め方相談 新規作成
 */
export const apiCreateClientHotlineRequestContact = ({ json, path: { hotline_request_id, id } }, meta) => apiCreate(API_UPDATE_CLIENT_HOTLINE_REQUEST_CONTACT_CREATE, `/client/hotline/${id}/request/${hotline_request_id}/contact`, json, meta);
